import styled from "styled-components";
import { MoreContainer } from "./DetailHeaderStyle";

export const DetailCategory = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 17px;
  gap: 10px;
  height: 20px;
  box-sizing: border-box;
  margin-top: 24px;

  & span {
    font-size: 12px;
    color: #4a5056;
    letter-spacing: -0.02em;
    text-align: center;
    padding: 1px 4px;
    background: #f1f3f5;
    border-radius: 4px;
  }
`;

export const PostInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  box-sizing: border-box;
  margin-bottom: 17px;

  & .profileInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & .profileImg {
      width: 32px;
      height: 32px;
      margin-right: 8px;
      border-radius: 50%;
    }

    & .nickAndCreateAt {
      margin: 0;
      letter-spacing: -0.02em;
      font-size: 12px;

      & .detail-nickname {
        height: 20px;
        line-height: 20px;
        font-weight: 500;
        color: #4a5056;
      }

      & .detail-createAt {
        height: 20px;
        line-height: 20px;
        font-weight: 400;
        color: #aeb5bc;
      }
    }
  }
`;

export const CommentMoreContainer = styled(MoreContainer)`
  margin-top: -17px;
`;

export const DetailContent = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  white-space: pre-wrap;

  & .contentUrlify {
    & a {
      word-break: break-word;
    }
  }

  & img {
    width: 328px;
  }

  & a {
    color: #000;
  }
`;

export const Embedded = styled.div`
  width: 100%;
  height: 80px;
  border: 1px solid #f1f3f5;
  border-radius: 8px;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;

  box-sizing: border-box;

  & a {
    height: 100%;
  }

  & article {
    display: flex;
    flex-wrap: nowrap;

    position: relative;
  }

  & main {
    width: 59%;
    height: 60px;
    margin: 10px 12px;

    box-sizing: border-box;

    overflow: hidden;
  }

  & h1 {
    font-size: 13px;
    line-height: 20px;
    margin-bottom: 3px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & div {
    display: inline-flex;
    overflow: hidden;

    width: 100%;
  }

  & p {
    //height: 45%;
    color: #878e95;
    font-size: 12px;
    line-height: 18px;

    overflow: hidden;
    text-overflow: ellipsis;

    display: -webkit-box;
    -webkit-line-clamp: 2; /* 라인수 */
    -webkit-box-orient: vertical;
    word-break: break-word;
    line-height: 18px;
    height: 18px * 2;
  }

  & span {
  }

  & img {
    //background-color: #f1f3f5;
    //object-fit: contain;
    object-fit: fill;
    width: 33%;
    height: 100%;
    position: absolute;
    right: 0;
    border-left: 1px solid #f1f3f5;
  }
`;

export const DetailAside = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 15px;
  letter-spacing: -0.02em;

  & .detail-liked {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* height: 20px; */

    font-size: 12px;
    /* line-height: 20px; */
    text-align: center;
    color: #878e95;
    box-sizing: border-box;

    & img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }

    & span {
      margin-left: 2px;
      margin-right: 4px;
    }

    & span:last-child {
      margin-right: 0;
    }
  }

  & .detail-comments {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 16px;
    font-size: 12px;
    letter-spacing: -0.02em;
    color: #878e95;

    & img {
      width: 17px;
      height: 17px;
      cursor: pointer;
    }

    & span {
      margin-left: 2px;
      margin-right: 2px;
      color: #878e95;

      cursor: pointer;
    }

    & span:last-child {
      margin-right: 0;
    }
  }
`;

export const DetailBoldLine = styled.div`
  height: 8px;
  background: #f8f9fa;
`;

export const DetailComments = styled.div`
  /* display: relative; */
  //padding-bottom: 68px;

  & .noComment {
    margin-top: 85px;
    margin-bottom: 60px;
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #878e95;

    box-sizing: border-box;
  }

  & .isComment {
    margin-bottom: 60px;
  }

  /* 댓글 입력 창 */
  & .commentsMargin {
    position: fixed;
    width: 92%;
    height: 15px;
    bottom: 57.5px;
    background-color: #fff;

    & .inputComments {
      position: fixed;
      bottom: 57.5px;

      margin: 10px 0;

      width: 92%;
      padding-left: 12px;
      padding-right: 12px;
      background: #f1f3f5;
      border-radius: 8px;
      box-sizing: border-box;

      & textarea {
        width: 100%;
        border: none;
        outline: none;
        resize: none;
        overflow: hidden;

        font-size: 14px;

        background: #f1f3f5;
        box-sizing: border-box;

        &::placeholder {
          font-size: 14px;
          letter-spacing: -0.02em;
          color: #4a5056;
        }

        &.blur {
          margin-top: 12px;
          margin-bottom: 8px;
        }

        &.focus {
          margin-top: 12px;
          margin-bottom: 8px;
          color: #4a5056;
          caret-color: #ff7a00;

          &::placeholder {
            color: #878e95;
          }
        }
      }

      & .textareaAside {
        display: flex;
        justify-content: space-between;
        padding-bottom: 8px;
        margin-top: 14px;
        color: #4a5056;
        box-sizing: border-box;

        & div {
          font-size: 12px;
        }

        & button {
          border: none;
          outline: none;
          font-size: 14px;

          &.orange {
            color: #ff7a00;
            font-weight: 700;
            cursor: pointer;
          }
          &.black {
            color: #000;
            font-weight: 400;
          }
        }
      }
    }
  }
`;

// export const TextareaAside = styled.div`
//   display: flex;
//   justify-content: space-between;
//   padding-bottom: 8px;
//   margin-top: 14px;
//   color: #4a5056;
//   box-sizing: border-box;

//   & div {
//     font-size: 12px;
//   }

//   & button {
//     border: none;
//     outline: none;
//     font-size: 14px;
//     cursor: pointer;
//   }
// `;
